module.exports = __webpack_public_path__ + "static/ai-poster@2x-0f44c7c1422a212256dd54a535971796.png";